// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var BillingPeriod = function (x) {
    return x;
};
var tsBridgeBillingPeriod = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("BillingPeriod")("__brandBillingPeriod"));
    }
};
var writeBillingPeriod = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showBillingPeriod = Data_Show.showString;
var readBillingPeriod = Simple_JSON.readString;
var ordBillingPeriod = Data_Ord.ordString;
var newtypeBillingPeriod = {
    Coercible0: function () {
        return undefined;
    }
};
var makeBillingPeriod = BillingPeriod;
var eqBillingPeriod = Data_Eq.eqString;
export {
    BillingPeriod,
    makeBillingPeriod,
    unwrap,
    newtypeBillingPeriod,
    eqBillingPeriod,
    ordBillingPeriod,
    showBillingPeriod,
    readBillingPeriod,
    writeBillingPeriod,
    tsBridgeBillingPeriod
};
//# sourceMappingURL=index.js.map
